<!--在elementui的inputNumber上封装多一层的inputnumber组件参数和用法和elementUI的inputNumber一样，多了个append插槽，append插槽用于在input框后面拼接单位
例子：
   <CustomInputNumber v-model="formdata.wheelbase" style="width:230px">
      <template slot="append">mm</template>
    </CustomInputNumber>
-->
<template>
  <div
    :class="[
      'custom-input-number',
      { 'custom-input-number-group': $slots.append },
    ]"
  >
    <el-input-number
      ref="customInputNumber"
      v-model="currentValue"
      class="input-num"
      :min="min"
      :max="max"
      :step="step"
      :stepStrictly="stepStrictly"
      :controls="controls"
      :precision="precision"
      :size="size"
      :disabled="disabled"
      :controlsPosition="controlsPosition"
      :name="name"
      :label="label"
      :placeholder="placeholder"
      @input="handleInput"
      @change="handleChange"
      @blur="handleBlur"
      @focus="handleFocus"
    >
    </el-input-number>

    <div class="unit" v-if="$slots.append">
      <slot name="append"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomInputNumber",
  props: {
    value: {},
    min: {
      type: Number,
      default() {
        return -Infinity;
      },
    },
    max: {
      type: Number,
      default() {
        return Infinity;
      },
    },
    step: {
      type: Number,
      default() {
        return 1;
      },
    },
    stepStrictly: {
      type: Boolean,
      default: false,
    },
    precision: {
      type: Number,
      validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      },
    },
    size: {
      validator(val) {
        if (val) {
          return ["large", "small"].indexOf(val) !== -1;
        }
        return true;
      },
      default() {
        return "";
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    controls: {
      type: Boolean,
      default: false,
    },
    controlsPosition: {
      type: String,
      default() {
        return "";
      },
    },
    name: {
      type: String,
      default() {
        return "";
      },
    },
    label: {
      type: String,
      default() {
        return "";
      },
    },
    placeholder: {
      type: String,
      default() {
        return "";
      },
    },
  },

  data() {
    return {
      currentValue:
        this.value !== "" && this.value >= 0 ? this.value : undefined,
    };
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
    },
    handleChange(newValue, oldValue) {
      this.$emit("change", newValue, oldValue);
    },
    handleBlur(e) {
      this.$emit("blur", e);
    },
    handleFocus(e) {
      this.$emit("focus", e);
    },
    focus() {
      this.$refs.customInputNumber.focus();
    },
    select() {
      this.$refs.customInputNumber.focus();
    },
  },
  watch: {
    value(val) {
      // if (val >= 0 || val < 0) {
      //   this.currentValue = val;
      // } else {
      //   this.currentValue = undefined;
      // }
      let val_1 = Number(val);
      if (isNaN(val_1)) {
        this.currentValue = undefined;
      } else {
        this.currentValue = val_1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-input-number {
  display: inline-block;
  width: 100%;
  position: relative;
  .input-num {
    width: 100%;
  }
  ::v-deep .el-input-number .el-input__inner {
    text-align: left !important;
  }
  .unit {
    background-color: #f5f7fa;
    color: #909399;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 3px;
    padding: 0 20px;
    width: 1px;
    white-space: nowrap;
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.custom-input-number-group {
  line-height: normal;
  display: inline-table;
  border-collapse: separate;
  border-spacing: 0;
  .input-num {
    vertical-align: middle;
    display: table-cell;
    ::v-deep .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
</style>
